import { expValEquals } from '@confluence/feature-experiments';

export const shouldUseAGGActivityV3 = (): boolean => {
	if (expValEquals('cc_migrate_activity_v3_recents_queries_to_agg', 'isEnabled', true)) {
		return true;
	}

	// We are migrating Activity V3 queries for custom domain tenants earlier due to a cc-graphql bug
	const isDefaultDomain =
		window.location.hostname.endsWith('.atlassian.net') ||
		window.location.hostname.endsWith('.jira-dev.com');

	return !isDefaultDomain;
};
